import type { WidgetPreset } from "../types";
import templateHtml from "./template.html?raw";

export const BIG_BRAIN: WidgetPreset = {
  id: "big-brain",
  label: "Big Brain Energy",
  defaultWidth: 144,
  defaultHeight: 144,
  html: templateHtml,
};
